import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { getCustomReport } from 'services/apiReport'

const useGetCustomReport = (params) => {
  const{isPending:isGetting, isSuccess: isGot, data: customReportData,refetch} = useQuery({
    queryKey:['customReportData',params],
    queryFn: ({queryKey})=>getCustomReport(queryKey[1]),
    enabled: !!params,
    keepPreviousData:true,
    staleTime: 2 * 60 * 60 * 1000,
  })

  return{isGetting, isGot, customReportData,refetch}
}

export default useGetCustomReport